import React from 'react';

const TableVal = ({text}:{text:string|null}) => {
    return (
        <>
            {text ? text : 'N/A'}
        </>
    );
};

export default TableVal;